<div class="tableComponent">
  <mat-table
    matSort
    tableSort
    tableFilter
    [disableFilter]="disableFilter"
    [filterPredicate]="filterPredicate"
    [tableColumnFilters]="tableColumnFilters"
    [searchFilter]="searchTerm$ | async"
    (matSortChange)="sortData($event)"
    [multiTemplateDataRows]="hasDetailsRow$ | async"
    [dataSource]="dataSource"
  >
    <ng-container *ngFor="let column of columns; trackBy: trackColumnFn" matColumnDef="{{ column.name }}">
      <mat-header-cell
        *matHeaderCellDef="let element"
        [ngClass]="getColumnCssClass(column.header, element)"
        [mat-sort-header]="column.table.displayValue"
        mat-sort-header
        [disabled]="column.disableSorting"
      >
        <table-header
          [element]="element"
          [header]="column.header"
          test-data="table-header"
          [attr.test-data-header-name]="column.name"
        >
        </table-header>
      </mat-header-cell>

      <mat-cell *matCellDef="let element" [ngClass]="getColumnCssClass(column.table, element)">
        <table-column
          [element]="element"
          [table]="column.table"
          test-data="table-cell"
          [attr.test-data-cell-name]="column.name"
          [attr.test-data-cell-id]="element.id"
        >
        </table-column>
      </mat-cell>
    </ng-container>

    <ng-container *ngIf="hasDetailsRow$ | async" matColumnDef="expandedDetail">
      <mat-cell *matCellDef="let element" [attr.colspan]="(displayedColumnNames$ | async).length">
        <div class="detail-table-row-content" [@detailExpand]="rowIsSelected(element) ? 'expanded' : 'collapsed'">
          <table-column [element]="element" [table]="tableDefinition.detailsRow"> </table-column>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumnNames$ | async; sticky: stickyHeader"></mat-header-row>
    <mat-row
      *matRowDef="let rowDataElement; columns: displayedColumnNames$ | async"
      (click)="rowClickHandler(rowDataElement)"
      (dblclick)="rowDblClickHandler(rowDataElement)"
      (mouseover)="mouseOverHandler(rowDataElement)"
      [ngClass]="[getSelectedRowClass(rowDataElement), getRowClass(rowDataElement)]"
      [class.detail-table-row-pre-row]="hasDetailsRow$ | async"
    >
    </mat-row>
    <ng-container *ngIf="hasDetailsRow$ | async">
      <mat-row
        *matRowDef="let rowDataElement; columns: ['expandedDetail']"
        class="detail-table-row"
        (click)="rowClickHandler(rowDataElement)"
      >
      </mat-row>
    </ng-container>
  </mat-table>

  <mat-paginator *ngIf="isPaged" [class.paginator--hidden]="isNoDataDisplayed()" (page)="pageChangedCallback($event)">
  </mat-paginator>

  <div class="not-found" test-data="no-data-found" *ngIf="isNoDataDisplayed()" [translate]="noDataFoundLabel"> </div>
</div>
